var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMailShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7240_24631)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7240_24631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 11.5859H41.375C43.4891 11.5859 45.2188 13.2075 45.2188 15.1895V36.8105C45.2188 38.7925 43.4891 40.4141 41.375 40.4141H10.625C8.51094 40.4141 6.78125 38.7925 6.78125 36.8105V15.1895C6.78125 13.2075 8.51094 11.5859 10.625 11.5859Z",
    fill: "url(#paint0_linear_7240_24631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9668 12.7153L26 25.4697L9.0332 12.7153",
    fill: "url(#paint1_linear_7240_24631)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41 48C41 48 49 44 49 38V31L41 28L33 31V38C33 44 41 48 41 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 48C41 48 49 44 49 38V31L41 28L33 31V38C33 44 41 48 41 48Z",
    fill: "url(#paint2_linear_7240_24631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2363 37.1178L39.7657 40.6472L45.6481 34.7649",
    stroke: "white",
    strokeWidth: 1.76471,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24631",
    x1: 26,
    y1: 11.5859,
    x2: 26,
    y2: 40.4141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6688FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F688F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24631",
    x1: 26,
    y1: 12.7153,
    x2: 26,
    y2: 25.4697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_24631",
    x1: 41,
    y1: 28,
    x2: 41,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7240_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7240_24631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4375,
    height: 38.4375,
    fill: "white",
    transform: "translate(6.78125 6.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailShield);
export default __webpack_public_path__ + "static/media/icon_mail_shield.75ca7e6a98e84a7c0cfed053fd26aced.svg";
export { ForwardRef as ReactComponent };